"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_select_1 = __importStar(require("react-select"));
const MenuIcon_1 = __importDefault(require("../MenuIcon/MenuIcon"));
const styles_1 = require("./styles");
const ModeDropdown = (props) => {
    let currentActive = props.availableModes.find((m) => m.mode === props.currentMode);
    if (!currentActive) {
        // Should never happen. Fallback for styleguide
        currentActive = {
            icon: props.currentMode,
            mode: props.currentMode,
            title: '',
            url: '',
        };
    }
    return (React.createElement(react_select_1.default, { id: "mode-dropdown", name: "mode-dropdown", components: { DropdownIndicator: null, ValueContainer: valueContainer }, value: { value: currentActive.url, label: currentActive.title }, styles: styles_1.customStyles(props.currentMode, true), options: props.availableModes.map((m) => ({
            label: m.title,
            value: m.url,
        })), onChange: handleChange, tabSelectsValue: false, openMenuOnFocus: true, isSearchable: false, placeholder: '' }));
    function valueContainer(controlProps) {
        return (react_select_1.components.ValueContainer && (React.createElement(react_select_1.components.ValueContainer, Object.assign({}, controlProps),
            React.createElement(MenuIcon_1.default, { type: "MODE", icon: props.currentMode }),
            controlProps.children)));
    }
    function handleChange(selectedItem) {
        if (selectedItem && !(selectedItem instanceof Array)) {
            window.location.replace(selectedItem.value);
        }
    }
};
exports.default = ModeDropdown;
//# sourceMappingURL=ModeDropdown.js.map